webpackJsonp([180754660315618],{

/***/ 1597:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":null},"pathContext":{"author":"/people/henry-debenham/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---authors-henry-debenham-459841c0ab6d3230211a.js